import { useEffect, type ReactNode } from "react";
import SiteHeader from "./SiteHeader";
import SiteFooter from "./SiteFooter";

type PageLayoutProps = {
  children: ReactNode;
  dark?: boolean;
  backToTop?: boolean;
};

export default function PageLayout({ children, dark = false, backToTop = true }: PageLayoutProps) {
  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);

  return (
    <div id="top" className="min-h-screen bg-background-50 text-foreground-950">
      <SiteHeader dark={dark} />
      <main>{children}</main>
      <SiteFooter />
      {backToTop && <BackToTop />}
    </div>
  );
}

function BackToTop() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!show) return null;
  return (
    <button
      type="button"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      aria-label="返回顶部"
      className="fixed bottom-6 right-6 z-40 flex h-11 w-11 items-center justify-center rounded-full bg-primary-500 text-background-50 shadow-lg transition-colors hover:bg-primary-600"
    >
      <i className="ri-arrow-up-line text-xl" />
    </button>
  );
}